module.exports = __webpack_public_path__ + "static/media/Cradle_2_Cradle_Certified.3ddd6f59.svg";